import { render, staticRenderFns } from "./PraticaAutotrasportoImballi.vue?vue&type=template&id=3a569138&"
import script from "./PraticaAutotrasportoImballi.vue?vue&type=script&lang=js&"
export * from "./PraticaAutotrasportoImballi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a569138')) {
      api.createRecord('3a569138', component.options)
    } else {
      api.reload('3a569138', component.options)
    }
    module.hot.accept("./PraticaAutotrasportoImballi.vue?vue&type=template&id=3a569138&", function () {
      api.rerender('3a569138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaAutotrasportoImballi.vue"
export default component.exports